export const NOMINAL_TABLE_OF_GENERAL_SUBSCRIPTIONS_BY_PERIOD =
  'tabel_nominal_abonamente_generale_pe_perioada.jrxml';
